import { TimePeriodOption } from './dashboard.types'

export const timePeriods: TimePeriodOption[] = [
  { key: '1d', label: 'dashboardAgent_1d' },
  { key: '1w', label: 'dashboardAgent_1w' },
  { key: '1M', label: 'dashboardAgent_1M' },
]
export const timePeriodsMobile: TimePeriodOption[] = [
  { key: '1d', label: 'dashboardAgent_1d' },
  { key: '1M', label: 'dashboardAgent_1M' },
]
